<template>
  <v-container fluid class="fancyback pa-0" style="height: inherit">
    <v-progress-linear :indeterminate="loading" v-if="loading" color="tertiary" absolute>
    </v-progress-linear>
    <v-row no-gutters v-if="isPcBool" style="height: inherit">
      <v-col cols="6" class="pb-4 px-1" style="height: inherit; overflow-y: auto; direction: rtl;">
        <div style="direction: ltr;" class="ml-2">
          <customer-card-list :customer="customer">
          </customer-card-list>
        </div>
        <div style="direction: ltr;" class="ml-2">
          <job-card :job="JobDetails">
          </job-card>
        </div>
      </v-col>
      <v-col cols="6" class="pl-2">
        <machine-card-list :disabled="JobDetails && JobDetails.JobStatusId >= 70"
          :machines="subjobs"></machine-card-list>
      </v-col>
    </v-row>

    <v-row no-gutters v-else class="px-4">
      <v-col cols="12">
        <customer-card-list :customer="customer"></customer-card-list>
      </v-col>
      <v-col cols="12">
        <job-card :job="JobDetails"></job-card>
      </v-col>
      <v-col cols="12">
        <machine-card-list :disabled="JobDetails && JobDetails.JobStatusId >= 70"
          :machines="subjobs"></machine-card-list>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import CustomerCardList from "@/views/job/newjob/cards/customer/CustomerCardList2.vue";
import MachineCardList from "@/views/job/newjob/cards/machines/MachineJobCardList.vue";
import JobCard from "@/views/job/newjob/cards/jobdetails/JobCard.vue";

export default {
  name: "ViewJobGeneral",
  components: {
    CustomerCardList,
    MachineCardList,
    JobCard,
  },

  data() {
    return {
      JobData: null,
      loading: false,
    };
  },

  mounted() { },

  methods: {},

  computed: {
    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },

    customer() {
      return this.$store.getters["JobHub/Customer"];
    },
    subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
  },
  watch: {
  },
};
</script>